<template>
  <div>
    <div class="holder">
      <img class="spinner-center" src="/static/img/others/spinner.svg" alt="Social login..." />
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import axios from 'axios'

  export default {
    created () {
      this.routeQuery = this.$route.query
      if (this.$route.query.denied || this.$route.query.error_reason) {
        window.opener.auth.user.socialError = true
        window.close()
        window.opener.auth.redirectSocial(false)
        return false
      }

      let provider = (this.$route.path.indexOf('facebook') >= 0 ? 'facebook' : 'twitter')
      let query = this.$route.query
      if (provider === 'facebook') {
        const routeString = this.$route.hash.substring(1)
        const queryParams = qs.parse(routeString)
        if (typeof queryParams !== 'undefined' && typeof queryParams.access_token !== 'undefined') {
          query = qs.stringify({ access_token: queryParams.access_token})
        }
      }
      this.validateToken(provider, query)
    },
    data () {
      return {
        routeQuery: ''
      }
    },
    methods: {
      processResponse (response) {
        window.opener.debug_response = response
        const notMobileVerified = response.data.success === false && typeof response.data.mobile_verified !== 'undefined' && response.data.mobile_verified === false
        if (response.data.error === true || notMobileVerified) {
          if (typeof response.data.fb_data !== 'undefined') {
            window.opener.auth.require_email = true
            window.opener.auth.prem_user_data = response.data.fb_data
            window.opener.auth.showRequireEmail(true)
            if (notMobileVerified && typeof response.data.profile_id !== 'undefined') {
              window.opener.auth.uuid = response.data.profile_id
              window.opener.auth.verifyPhone(true, response.data.profile_id)
            }
          }
          throw response.data.message
        } else {
          localStorage.setItem('auth_token', response.data.token)
          localStorage.setItem('profile_id', response.data.profile_id)
          localStorage.setItem('mobile', response.data.mobile)
          localStorage.setItem('displayName', response.data.displayName)
          localStorage.setItem('avatar', response.data.avatar)

          window.opener.user = response.data
          window.opener.auth.redirectSocial(true)
        }
      },
      validateToken (provider, query) {
        let url = `/consumer/social-login/${provider}/verify`
        if (provider === 'facebook') {
          url = `/consumer/social-login/${provider}/verify?${query}`
        }

        axios.get(url)
          .then((response) => {
            try {
              this.processResponse(response)
            } catch (err) {
              console.log('register response object', response)
              window.opener.auth.socialError = true
              window.opener.auth.error_message = err
              window.opener.auth.error = true
              window.opener.error_response = response
              if (typeof response.data.fb_data !== 'undefined') {
                window.opener.auth.require_email = true
                window.opener.auth.prem_user_data = response.data.fb_data
                window.opener.auth.showRequireEmail(true)
              }
              window.opener.auth.redirectSocial(false)
            }
            window.close()
          })
          .catch((error) => {
            console.log('error', error)
            window.opener.auth.user.socialError = true
            window.opener.auth.user.error = true
            window.opener.auth.user.error_message = `There is no account with these credentials. Please <a href="/register"><span class="text-white font-weight-bold">create a new account to continue</span></a>`
            // window.opener.auth.onChange(false)
            window.opener.auth.user.error_details = error
            window.opener.auth.showError(window.opener.auth.user.error_message, error)
            // window.close()
          })
      }
    }
  }
</script>
<style scoped>
.spinner-center {
  display: block;
  width: 40px;
  height: 40px;
  margin: 0 auto;
}

.holder {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/SocialRedirect.vue